import styled from 'styled-components';

export const EcouponContainerStyled = styled.div`
  .product_item {
    margin-bottom: 20px;
    cursor: pointer;
  }
`;
